import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';

import Text from 'components/common/Text';
import QnaItem from './components/QnaItem';
import { useQnaListHooks } from './hooks/useQnaListHooks';
import QnaItemBottomSheet from './components/QnaItemBottomSheet';
import Divider from 'components/Divider';
import QnaFilterBottomSheet from './components/QnaFilterBottomSheet';
import TotalCountContainer from './components/TotalCountContainer';
import PaginationContainer from './components/PaginationContainer';
import Column from 'components/common/Column';
import { useQnaFilterHooks } from './hooks/useQnaFilterHooks';
import { useResizeDetector } from 'react-resize-detector';
import Loading from 'components/Loading/Loading';
import HackleManager from 'utils/hackle';
import { MAX_WIDTH } from 'App';
import ContentsTopBar from 'components/common/ContentsTopBar';
import WrapperContainer from 'components/common/Wrapper';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 0 0 90px;
  width: 100%;
  max-width: 768px;
  min-height: 100vh;
  background-color: #fff;
`;

const QnAListPage = () => {
  const {
    productId,
    isOpenCountFilter,
    qnaList,
    selectedQnaItem,
    isOpenQnaBottomSheet,
    isOpenQnaFilterBottomSheet,
    qnaFilter,
    // qnaCount,
    handleSetQnaFilter,
    setIsOpenQnaFilterBottomSheet,
    setIsOpenQnaBottomSheet,
    handleSelectedQnaItem,
    handleIsOpenCountFilter,
    handleSetProductQnaItem,
    handleAcceptFilter,
    handleReFetechList,
  } = useQnaListHooks();

  const {
    searchValue,
    termWithType,
    termType,
    statusIn,
    setStatusIn,
    setTermType,
    handleSetTermWithType,
    handlerSetSearchValue,
    handleResetFilterInput,
  } = useQnaFilterHooks();

  const { width, ref } = useResizeDetector();

  const isMobile = width ? width <= MAX_WIDTH : window.innerWidth <= MAX_WIDTH;

  const handleOpenBottomSheet = () => {
    setIsOpenQnaFilterBottomSheet(true);
  };

  useEffect(() => {
    if (qnaList) {
      HackleManager.logQnaView(
        qnaList.totalCount,
        statusIn === 'ALL' ? '전체' : statusIn === 'NEW' ? '미답변' : '답변',
      );
    }
  }, [qnaList]);

  if (!qnaList) {
    return <Loading />;
  }

  return (
    <WrapperContainer isMobile={isMobile}>
      <Container ref={ref}>
        <ContentsTopBar
          isMobile={isMobile}
          title="문의 관리"
          isAcceptFilter={
            searchValue !== '' || termType !== 'all' || statusIn !== 'ALL'
          }
          isShowFilter={true}
          onClick={handleOpenBottomSheet}
        />
        <Column gap="24px">
          <Column
            style={{
              padding: isMobile ? '0 20px' : '0 40px',
            }}
          >
            <TotalCountContainer
              totalCount={qnaList.totalCount}
              isOpenCountFilter={isOpenCountFilter}
              filterItem={qnaFilter}
              handleSetFilterItem={handleSetQnaFilter}
              handleIsOpenCountFilter={handleIsOpenCountFilter}
            />
          </Column>
          {!isEmpty(qnaList.edges) ? (
            qnaList.edges.map((item, idx) => {
              return (
                // 순번을 key 로 쓰면 미답변 필터에서 답변 후 목록이 당겨질 때
                // 다음 문의가 이전 문의의 입력 상태(작성한 답변)를 그대로 물려받는다
                <React.Fragment key={item.node.id}>
                  <QnaItem
                    isMobile={isMobile}
                    item={item}
                    handleSelectedQnaItem={handleSelectedQnaItem}
                    handleRefetchList={handleReFetechList}
                  />
                  {qnaList.edges.length !== idx + 1 && (
                    <Divider style={{ height: '6px', background: '#f4f4f5' }} />
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <Column gap="8px" style={{ minHeight: '60vh' }}>
              <Text color="#1b1c1e" size="16px">
                조회되는 문의가 없어요.
              </Text>
              <Text color="#70737c" weight={400}>
                필터를 다시 확인해 주세요
              </Text>
            </Column>
          )}
          <PaginationContainer
            totalCount={qnaList.totalCount}
            page={qnaFilter.page}
            size={qnaFilter.size}
            handleSetQnaFilter={handleSetQnaFilter}
          />
        </Column>
        {isOpenQnaBottomSheet && (
          <QnaItemBottomSheet
            type="qna"
            isMobile={isMobile}
            productInfo={selectedQnaItem.node.product}
            handleSetProductQnaItem={handleSetProductQnaItem}
            onClose={() => setIsOpenQnaBottomSheet(false)}
          />
        )}
        {isOpenQnaFilterBottomSheet && (
          <QnaFilterBottomSheet
            isMobile={isMobile}
            qnaFilter={qnaFilter}
            searchValue={searchValue}
            termWithType={termWithType}
            termType={termType}
            statusIn={statusIn}
            setStatusIn={setStatusIn}
            setTermType={setTermType}
            handleSetTermWithType={handleSetTermWithType}
            handlerSetSearchValue={handlerSetSearchValue}
            handleResetFilterInput={handleResetFilterInput}
            onClose={() => setIsOpenQnaFilterBottomSheet(false)}
            handleAcceptFilter={handleAcceptFilter}
          />
        )}
      </Container>
    </WrapperContainer>
  );
};

export default QnAListPage;
